import React, { useEffect, useState } from 'react';
import MapView from './MapView';

interface Sight {
    id: string;
    name: string;
    description: string;
    latitude: number;
    longitude: number;
    imageUrl?: string;
}

const API_URL = 'https://c6lw6r6gl2.execute-api.us-east-1.amazonaws.com/Prod/sights';

const App: React.FC = () => {
    const [sights, setSights] = useState<Sight[]>([]);
    const [selectedSight, setSelectedSight] = useState<Sight | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchSights = async () => {
            try {
                const response = await fetch(API_URL);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setSights(data);
            } catch (err: any) {
                console.error('Error fetching sights:', err);
                setError('Failed to load sights data.');
            } finally {
                setLoading(false);
            }
        };

        fetchSights();
    }, []);

    return (
        <div style={{ display: 'flex', height: '100vh' }}>
            <div style={{ flex: 1 }}>
                {loading && <p>Loading sights...</p>}
                {error && <p style={{ color: 'red' }}>{error}</p>}
                {!loading && !error && (
                    <MapView sights={sights} onSelectSight={setSelectedSight} />
                )}
            </div>
            <div
                style={{
                    flex: 1,
                    padding: '1rem',
                    borderLeft: '1px solid #ccc',
                    overflowY: 'auto',
                }}
            >
                {selectedSight ? (
                    <>
                        <h2>{selectedSight.name}</h2>
                        <p>{selectedSight.description}</p>
                        {selectedSight.imageUrl && (
                            <img
                                src={selectedSight.imageUrl}
                                alt={selectedSight.name}
                                style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
                            />
                        )}
                    </>
                ) : (
                    <p>Select a marker to view details.</p>
                )}
            </div>
        </div>
    );
};

export default App;
